export enum SystemMessage {
  UNKNOWN_ERROR = "Something's wrong",
  INPUT_REQUIRED = "Không được để trống",
  INPUT_INVALID_PRICE = "Giá không hợp lệ",
  INPUT_INVALID_EXPIRED_TIME = "Thời gian hiệu lực không hợp lệ",
  INPUT_INVALID_POINT = "Điểm không hợp lệ",
  INPUT_INVALID_VALUE = "Giá trị không hợp lệ",
  COPY_SUCCESSFULLY = "Đã sao chép",
  ADD_SUCCESSFULLY = "Tạo thành công",
  IMPORT_SUCCESSFULLY = "Nhập thành công",
  UPDATE_SUCCESSFULLY = "Cập nhật thành công",
  DELETE_SUCCESSFULLY = "Xóa thành công",
  RESTORE_SUCCESSFULLY = "Khôi phục thành công",
  CONFIRM_SUCCESSFULLY = "Xác nhận thành công",
  DELETE_BOOK_NOTIFY = "Bạn có chắc chắn muốn xóa sách này?",
  DELETE_PERMANENTLY_BOOK_NOTIFY = "Bạn có chắc chắn muốn xóa vĩnh viễn sách này?",
  RESTORE_BOOK_NOTIFY = "Bạn có muốn khôi phục sách này?",
  DELETE_CATEGORY_NOTIFY = "Bạn có chắc chắn muốn xóa danh mục này?",
  DELETE_BG_MUSIC_NOTIFY = "Bạn có chắc chắn muốn xóa nhạc nền này?",
  DELETE_MEDIA_NOTIFY = "Bạn có chắc chắn muốn xóa media này?",
  DELETE_BOOK_SEGMENT_NOTIFY = "Bạn có chắc chắn muốn xóa book segment này?",
  DELETE_BANK_NOTIFY = "Bạn có chắc chắn muốn xóa ngân hàng này?",
  DELETE_BANNER_NOTIFY = "Bạn có chắc chắn muốn xóa banner này?",
  DELETE_FEED_NOTIFY = "Bạn có chắc chắn muốn xóa feed này?",
  DELETE_BOOK_TIME_NOTIFY = "Bạn có chắc chắn muốn xoá cài đặt khung giờ này?",
  DELETE_ADVERTISE_NOTIFY = "Bạn có chắc chắn muốn xóa quảng cáo này?",
  CONFIRM_TRANSACTION_NOTIFY = "Bạn có chắc chắn muốn xác nhận giao dịch này?",
  MAX_SIZE_UPLOAD = "Chọn file nhỏ hơn 512 MB",
  EMAIL_ADDRESS_INVALID = "Địa chỉ email không hợp lệ",
  FULL_NAME_REQUIRED = "Vui lòng nhập họ và tên của bạn.",
  USERNAME_REQUIRED = "Tên đăng nhập không thể để trống!",
  PASSWORD_REQUIRED = "Vui lòng nhập mật khẩu.",
  CONFIRM_PASSWORD_REQUIRED = "Vui lòng nhập lại mật khẩu.",
  CONFIRM_PASSWORD_INVALID = "Mật khẩu nhập lại không khớp.",
  AGREE_TERMS_REQUIRED = "Bạn chưa đồng ý với điều khoản sử dụng.",
  TRANSFER_SUCCESSFULLY = "Chuyển khoản thành công",
  TIMEOUT = "Hết thời gian",
  ACCESS_DENIED = "Không có quyền truy cập",
  FILE_TYPE_NOT_ALLOW = "Vui lòng chọn tệp có định dạng: csv, xlsx, txt",
  INVALID_OTP = "OTP không hợp lệ",
  VERIFY_OTP_SUCCESSFULLY = "Xác nhận OTP thành công",
  VERIFY_OTP_FAILED = "Xác nhận OTP thất bại",
  DELETE_CONTENT_NOTIFY = "Bạn có chắc chắn muốn xóa nội dung này?",
  CONFIRM_PASSWORD_MISMATCH = "Mật khẩu xác nhận không khớp",
  DELETE_NOTIFICATION_NOTIFY = "Bạn có chắc chắn muốn xóa thông báo này?",
  DELETE_CAMPAIGN_NOTIFY = "Bạn có chắc chắn muốn xóa campaign này?",
  CREATE_TRANSCRIPTION_SUCCESS = "Yêu cầu của bạn sẽ sớm được xử lý",
}
